// extracted by mini-css-extract-plugin
export default {"inputfield":"TechnikField_inputfield__qfRvB","element":"TechnikField_element__K3nXj"};